import { styled } from "@mui/system";
import Dialog from "@mui/material/Dialog";

export default function ManualEntryModal({ open, children }) {
  const StyledDialog = styled(Dialog)(() => ({
    "& .MuiDialog-container": {
      background: "rgba(122, 122, 122, 0.50)",
    },

    "& .MuiDialog-paper": {
      padding: "var(--spacing-2xl)",
      borderRadius: "16px",
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    },
  }));

  return <StyledDialog open={open}>{children}</StyledDialog>;
}
